import httpClient from "./httpClient.js";
import { IUniform, ICreateUniform, IUpdateUniform } from '../interfaces/IUniform';

const prefix = "/uniform";

export async function createUniform(uniform: ICreateUniform): Promise<IUniform> {
  return (await httpClient.post(prefix, uniform)).data;
}

export async function getUniformsByPosition(positionId: number): Promise<IUniform[]> {
  return (await httpClient.get(`${prefix}/position/${positionId}`)).data;
}

export async function updateUniform(id: number, uniform: IUpdateUniform): Promise<IUniform> {
  return (await httpClient.patch(`${prefix}/${id}`, uniform)).data;
}

export async function deleteUniform(id: number): Promise<void> {
  return (await httpClient.delete(`${prefix}/${id}`)).data;
}

export async function getAllUniforms(): Promise<IUniform[]> {
  return (await httpClient.get(prefix)).data;
}
